const plannedColumns = [
  {
    title: '',
    enTitle: 'Title',
    width: 300,
    dataIndex: 'titleText',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'nameText',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Affiliations',
    width: 300,
    dataIndex: 'affiliation',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Abstract',
    width: 300,
    dataIndex: 'summaryText',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 150,
    dataIndex: 'updateTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 150,
    dataIndex: 'operator',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 180,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
const publishedColumns = [
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 150,
    dataIndex: 'code'
  },
  {
    title: '',
    enTitle: 'DOI',
    width: 220,
    dataIndex: 'doi'
  },
  {
    title: '',
    enTitle: 'Title',
    width: 400,
    dataIndex: 'titleText',
    slot: 'omis'
  },
  // {
  //   title: '',
  //   enTitle: 'Assigned Editor',
  //   width: 120,
  //   dataIndex: 'readNum',
  //   slot: 'readNum'
  // },
  {
    title: '',
    enTitle: 'Submission Time',
    width: 170,
    dataIndex: 'submittedDate',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 80,
    dataIndex: 'status',
    slot: 'publish'
  },
  {
    title: '',
    enTitle: 'Published Time',
    width: 170,
    dataIndex: 'publishedDate',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Updated Time',
    width: 170,
    dataIndex: 'updateTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 120,
    dataIndex: 'operator',
    slot: 'operator'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 170,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import { topic } from '@/api/topics'
import article from '@/api/article'
import journal from '@/api/journal'
import Add from './add.dialog.vue'
import help from '@/utils/help'
export default {
  components: {
    SiteSearchGroup,
    Add
  },
  data() {
    return {
      columns: publishedColumns,
      keyword: '',
      type: 'published',
      detail: {},
      dataSource: [],
      id: '',
      isVisable: false,
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      }
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      country: 'getCountry',
      editorialBoard: 'getEditorialBoard',
      user: 'getUser'
    })
  },
  mounted() {
    const { id } = this.$route.params
    this.id = id
    this.getDetail(id)
  },
  methods: {
    async getDetail(id) {
      this.detail = await topic.query(id)
      this.getList()
    },
    changeType(val) {
      this.type = val
      switch (val) {
        case 'published':
          this.columns = publishedColumns
          break
        case 'planned':
          this.columns = plannedColumns
          break
      }
      this.getList()
    },
    async getList(page = 1) {
      let fun = ''
      switch (this.type) {
        case 'published':
          fun = topic.getArticle
          break
        case 'planned':
          fun = topic.getParticle
          break
      }
      const data = {
        keyword: this.keyword,
        pageIndex: page,
        pageSize: this.pagination.size
      }
      const { list, pageIndex, pageSize, total } = await fun(this.id, data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    add() {
      this.isVisable = true
    },
    edit(val) {
      this.$refs['planned-paper-add'].getQuery(val.id)
      this.isVisable = true
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this article?',
        content:
          'Please be aware of once this article is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await topic.delParticle(this.id, val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Article has been deleted!'
        })
        this.getList()
      })
    },
    editArticle(val) {
      this.$router.push(
        `/publishing/publication/${val.id}?journalId=${this.detail.journalId}`
      )
    },
    delArticle(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this article?',
        content:
          'Please be aware of once this article is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await article.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Article has been deleted!'
        })
        this.getList()
      })
    },
    async able(val, status) {
      const { id, version } = val
      await article.changeStatus([
        {
          id,
          status,
          version
        }
      ])
      let content = `This Article has been ${status.toLowerCase()}!`
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    async exp() {
      let res = ''
      if (this.type === 'published') {
        res = await topic.articleExp(this.id, this.params)
      } else {
        res = await topic.particleExp(this.id, this.params)
      }
      help.download(res.url, res.fileName)
    },
    handleClear() {
      this.keyword = ''
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    },
    async openWebsite(val) {
      const { name } = await journal.query(val.journalId)
      let url = `/journal/${name}/test/article/${
        val.id
      }?token=${localStorage.getItem('token')}`
      const { host } = window.location
      if (
        host.includes('192.168.5') ||
        host.includes('192.168.4.34') ||
        host.includes('102.168.4.21') ||
        host.includes('localhost')
      ) {
        url = 'http://192.168.4.35:3020' + url
      } else if (
        host.includes('192.168.4.23') ||
        host.includes('imrpress.tech:9100')
      ) {
        url = 'http://www.imrpress.tech' + url
      } else if (host.includes('imrpress.tech:8100')) {
        url = 'http://www.imrpress.tech:9000' + url
      } else if (host.includes('propub.com')) {
        url = 'https://www.imrpress.com' + url
      } else {
        url = 'http://192.168.4.35:3020' + url
      }
      window.open(url)
    }
  }
}
